var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container info"},[_c('div',{staticClass:"offset-center border"},[_c('h3',[_vm._v(_vm._s(this.totalVideos)+" videos so far :)")])])])}
var staticRenderFns = []

export { render, staticRenderFns }